// extracted by mini-css-extract-plugin
export var container = "styles-module__container___BCkfI";
export var dropdownText = "styles-module__dropdownText____fN1N";
export var expandable = "styles-module__expandable___JGSnM";
export var header = "styles-module__header___h_1Wj";
export var needHelp = "styles-module__needHelp___PeVBH";
export var noBottomBorder = "styles-module__noBottomBorder___WGLeH";